import React, {useContext, useEffect, useRef, useState} from "react";
import {CarritoComprasPasos} from "../CarritoComprasPasos";
import {ListaRegistroDominiosPasoCuatro} from "./ListaRegistroDominiosPasoCuatro";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {CarritoComprasTotal} from "../CarritoComprasTotal";
import AppContext from "../../../store/AppContext";
import CarritoService from "../../../services/CarritoService";
import {MensajeError} from "../../MensajeError";
import {ValidacionAutenticado} from "../../../components/validaciones/ValidacionAutenticado";
import {ValidacionesCarrito} from "../../../components/validaciones/ValidacionesCarrito";
import {ListaRenovacionDominiosPasoDos} from "../paso_02/ListaRenovacionDominiosPasoDos";
import {ListaRenovacionDominiosPasoCuatro} from "./ListaRenovacionDominiosPasoCuatro";
import FeedbackSpinner from "../../../components/feedback/FeedbackSpinner";
import {ListaTransferenciasTitularPasoCuatro} from "./ListaTransferenciasTitularPasoCuatro";

export const CarritoComprasPasoCuatro = () => {
    const appCtx = useContext(AppContext);
    const history = useNavigate();
    const location = useLocation();
    const [templateCuentaPago, setTemplateCuentaPago] = useState();
    const [error, setError] = useState({
        error: false,
        mensaje: "Sin errores"
    });
    const [compraConfirmada, setCompraConfirmada] = useState(false);
    // Bloqueo sincrónico contra doble envío: el estado de React no se actualiza hasta el próximo render
    const enviandoRef = useRef(false);
    let carritoRegistros = appCtx.carrito.registrosPendientes;
    let carritoRenovaciones = appCtx.carrito.renovacionesPendientes;
    let carritoTransferenciasTitular = appCtx.carrito.transferenciasTitularPendientes;
    let venta = appCtx.venta;
    let subTotal = 0;
    let subTotalRegistros = 0;
    let subTotalRenovaciones = 0;
    let subTotalTransferenciasTitular = 0;

    let descuento = 0;

    const [isProcesandoCompra, setIsProcesandoCompra] = useState(false);
    const [operationId, setOperationId] = useState(null);

    useEffect(() => {
        setIsProcesandoCompra(false);

        if (location.state && location.state.errorValidacionCarrito.error) {
            setError(location.state.errorValidacionCarrito);
        }

        if (venta !== undefined && venta.uuidVenta !== "") {
            obtenerFormaPagoGuradadaVenta(venta);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!operationId) {
            return;
        }

        const startedAt = Date.now();
        const MAX_WAIT_MS = 120000;

        const intervalId = setInterval(async () => {
            try {
                if (Date.now() - startedAt > MAX_WAIT_MS) {
                    // La venta sigue en proceso: no se habilita el botón para no permitir una segunda confirmación
                    clearInterval(intervalId);
                    setIsProcesandoCompra(false);
                    setOperationId(null);
                    appCtx.clean();
                    history('/carrito-compra-paso-cinco',
                        {
                            state: {
                                mensajeOk: { mostrarMensaje: false, mensaje: '' },
                                error: {
                                    error: true,
                                    mensaje: 'La compra sigue en procesamiento. Podés continuar navegando y revisar más tarde en Mis dominios.'
                                }
                            }
                        });
                    return;
                }

                let estadoCompra;
                try {
                    estadoCompra = await CarritoService.obtenerEstadoCompra(operationId);
                } catch (e) {
                    // Un error puntual consultando el estado no indica que la compra haya fallado: se sigue consultando
                    return;
                }

                if (!estadoCompra || estadoCompra.status === 'PENDING' || estadoCompra.status === 'RUNNING'
                    || estadoCompra.status === 'NOT_STARTED') {
                    return;
                }

                clearInterval(intervalId);
                setCompraConfirmada(false);
                setIsProcesandoCompra(false);
                setOperationId(null);
                appCtx.clean();

                if (estadoCompra.status === 'SUCCESS') {
                    history('/carrito-compra-paso-cinco',
                        {
                            state: {
                                mensajeOk: { mostrarMensaje: true, mensaje: 'Tu compra se realizó con éxito.' },
                                error: { error: false, mensaje: 'Sin errores.' }
                            }
                        });
                    return;
                }

                history('/carrito-compra-paso-cinco',
                    {
                        state: {
                            mensajeOk: { mostrarMensaje: false, mensaje: '' },
                            error: { error: true, mensaje: estadoCompra.message || 'Error al procesar la confirmación de la compra.' }
                        }
                    });
            } catch (e) {
                // No se habilita el botón: no se sabe en qué estado quedó la compra
                clearInterval(intervalId);
                setIsProcesandoCompra(false);
                setOperationId(null);

                const mensaje = (e?.response?.data?.mensaje ?? e?.response?.data?.message ?? e?.message) || 'Error al consultar el estado de la compra.';
                setError({
                    error: true,
                    mensaje
                });
            }
        }, 2500);

        return () => clearInterval(intervalId);
    }, [operationId, appCtx, history]);

    function calcularSubtotal(items) {
        let subTotalAux = 0;
        if (items.length > 0) {
            items.forEach((dominio) => {
                if (dominio.anios === undefined ){
                    subTotalAux = subTotalAux + (dominio.precio);
                }else{
                    subTotalAux = subTotalAux + (dominio.precio * dominio.anios);
                }
            })
        }
        return subTotalAux;
    }

    subTotalRegistros = calcularSubtotal(carritoRegistros);
    subTotalRenovaciones = calcularSubtotal(carritoRenovaciones);
    subTotalTransferenciasTitular = calcularSubtotal(carritoTransferenciasTitular);

    subTotal = subTotalRegistros + subTotalRenovaciones + subTotalTransferenciasTitular;

    const utilizaDatosFacturacion = false;

    const obtenerFormaPagoGuradadaVenta = (venta) => {
        CarritoService.obtenerFormaPagoGuardadaVenta(venta.uuidVenta)
            .then(response => {
                if (response.esRespOK) {
                    setTemplateCuentaPago(response.cuentaPago);
                } else {
                    setError({
                        error: true,
                        mensaje: "Error al obtener la forma de pago guardada"
                    });
                }
            })
        return templateCuentaPago;
    }

    const confirmarCompra = (event) => {

        event.preventDefault();
        if (enviandoRef.current || compraConfirmada) {
            return;
        }
        enviandoRef.current = true;
        setCompraConfirmada(true);
        setIsProcesandoCompra(true);

        const uuidVenta = appCtx.venta.uuidVenta;
        CarritoService.finalizarCompraAsync(uuidVenta)
            .then(response => {
                if (response && response.status === 'ERROR') {
                    throw new Error(response.message || 'No se pudo iniciar el procesamiento de la compra.');
                }
                if (response && response.operationId) {
                    setOperationId(response.operationId);
                } else {
                    throw new Error('No se recibió operationId para consultar el estado de la compra.');
                }
            }).catch(async (error) => {
            // El pedido pudo haber llegado al backend aunque la respuesta falle: si la venta ya empezó
            // a procesarse se retoma el seguimiento en vez de permitir otra confirmación
            const ventaEnProceso = await consultarSiVentaEnProceso(uuidVenta);
            if (ventaEnProceso) {
                setOperationId(uuidVenta);
                return;
            }

            const mensaje = (error?.response?.data?.mensaje ?? error?.response?.data?.message ?? error?.message) || 'Error al procesar la confirmación de la compra.';
            setError({
                error: true,
                mensaje
            });
            enviandoRef.current = false;
            setCompraConfirmada(false);
            setIsProcesandoCompra(false);
        });
    }

    const consultarSiVentaEnProceso = async (uuidVenta) => {
        try {
            const estadoCompra = await CarritoService.obtenerEstadoCompra(uuidVenta);
            return !!estadoCompra && ['PENDING', 'RUNNING', 'SUCCESS'].includes(estadoCompra.status);
        } catch (e) {
            return false;
        }
    }

    const validarFormaDePagoCarrito = (template) => {
        //validar que la venta tenga template de pago
        return template !== undefined
                    && template !== null
                    && template.cuenta !== undefined
                    && template.cuenta !== null;
    }

    return (
      <>
        {error !== undefined && error.error && <MensajeError mensajeError={error.mensaje}/>}

        { isProcesandoCompra?
            <div>
                <FeedbackSpinner open={isProcesandoCompra} message={'Procesando ...'}/>
            </div> : <></>
        }

        <ValidacionAutenticado/>

        <ValidacionesCarrito paso={4} setError={setError}/>

        <CarritoComprasPasos paso={4}
                               tituloCarrito={'Carrito de compras'}
                               parrafoCarrito={''}
          />

        <br clear="all"/>

        <form id="id-form-finalizar-venta">

            { utilizaDatosFacturacion &&
                <fieldset className="left half">
                    <legend>Datos de facturación</legend>
                    <div className="form-item">
                        <label htmlFor="">Apellido</label> Apellido
                    </div>

                    <div className="form-item">
                        <label htmlFor="">Nombre</label> Nombre
                    </div>

                    <div className="form-item">
                        <label htmlFor="">Domicilio constituido en Uruguay</label> Dirección
                        <p>Los datos ingresados deben ser verdaderos, son tenidos en cuenta para cualquier gestión</p>
                    </div>

                    <div className="form-item">
                        <label htmlFor="">Ciudad</label> Ciudad
                    </div>

                    <div className="form-item">
                        <label htmlFor="">País</label> País
                    </div>

                    <div className="form-item">
                        <label htmlFor="">Tipo de documento</label> Tipo de documento
                    </div>

                    <div className="form-item">
                        <label htmlFor="">Número de documento</label> Número de documento
                    </div>
                </fieldset>
            }

            { validarFormaDePagoCarrito(templateCuentaPago) &&
                <fieldset className="left half">
                  <legend>Forma de pago</legend>
                  <p><strong>Débito en la factura de telefonía fija o datos de Antel.</strong></p>
                  <br/>
                      <div className="form-item">
                          <label>Pa&iacute;s</label>{templateCuentaPago !== undefined ? templateCuentaPago.cuenta.pais.nombre : ''}
                      </div>
                      <div className="form-item">
                          <label>Tipo de documento</label>{templateCuentaPago !== undefined ? templateCuentaPago.cuenta.tipoDocumento.nombre : ''}
                      </div>
                      <div className="form-item">
                          <label>Número de documento</label>{templateCuentaPago !== undefined ? templateCuentaPago.cuenta.nroDocumento : ''}
                      </div>
                      <div className="form-item">
                          <label>Nro. de Cuenta</label>{templateCuentaPago !== undefined ? templateCuentaPago.cuenta.cuenta : ''}
                      </div>
                </fieldset>
            }

            <br clear="all"/>
            <hr/>

            <ListaRegistroDominiosPasoCuatro subTotal={subTotalRegistros}></ListaRegistroDominiosPasoCuatro>
            <ListaRenovacionDominiosPasoCuatro subTotal={subTotalRenovaciones} errorEnCarrito={setError}/>
            <ListaTransferenciasTitularPasoCuatro subTotal={subTotalTransferenciasTitular} errorEnCarrito={setError}/>

            <CarritoComprasTotal subTotal={subTotal} descuento={descuento}/>

            <br clear="all"/>
            <div className="right">
                <button id="id-submit-carrito" className="btn" onClick={confirmarCompra} disabled={compraConfirmada}>{!compraConfirmada ? "Confirmar compra": "Procesando..."}</button>
            </div>
            <br clear="all"/>
            <p>
                <Link to={{ pathname: "/carrito-compra-paso-tres"}}>Volver al paso anterior</Link>
            </p>

        </form>

        <div className="right"></div>
      </>
    );
};